import React, {Dispatch, FC, SetStateAction} from 'react';
import {Col, Form, Row} from 'react-bootstrap';
import {AbuseOptionsEmoji, AbuseWord} from 'services/abuseWordsService';
import {AbuseWordModalFormSection} from 'pages/AbuseWords/components/AbuseWordModalFormSection';

type Props = {
    word: AbuseWord;
    setWord: Dispatch<SetStateAction<AbuseWord>>;
};

export const AbuseWordModalPatternSection: FC<Props> = ({word, setWord}) => (
    <div className="border rounded-3 p-3 p-lg-4 border-2">
        <AbuseWordModalFormSection label="Паттерн" controlId="abuse-word-pattern">
            <Form.Control
                className="font-monospace"
                type="text"
                placeholder="Например: ruderomp"
                value={word.pattern}
                onChange={e => setWord(w => ({...w, pattern: e.target.value}))}
            />
        </AbuseWordModalFormSection>
        <div className="fw-semibold text-secondary small text-uppercase mb-2">Опции поиска</div>
        <Row className="g-3">
            <Col sm={6}>
                <div className="form-check">
                    <input className="form-check-input" type="checkbox"
                           id="abuse-opt-delimiters"
                           checked={word.allowDelimiters}
                           onChange={(e) => setWord(w => ({...w, allowDelimiters: e.target.checked}))}/>
                    <label className="form-check-label" htmlFor="abuse-opt-delimiters"
                           title="Пробелы, знаки препинания и т.п. внутри совпадения">
                        Разделители {AbuseOptionsEmoji.Delimiters}
                    </label>
                    <div className="small text-muted ms-4 ps-1">Внутри слова допускаются пробелы и пунктуация</div>
                </div>
            </Col>
            <Col sm={6}>
                <div className="form-check">
                    <input className="form-check-input" type="checkbox" id="abuse-opt-multiline"
                           checked={word.allowMultiline}
                           onChange={(e) => setWord(w => ({...w, allowMultiline: e.target.checked}))}/>
                    <label className="form-check-label" htmlFor="abuse-opt-multiline"
                           title="Паттерн может быть разбит на несколько строк">
                        Многострочный {AbuseOptionsEmoji.Multiline}
                    </label>
                    <div className="small text-muted ms-4 ps-1">Совпадение может переноситься на новую строку</div>
                </div>
            </Col>
            <Col sm={6}>
                <div className="form-check">
                    <input className="form-check-input" type="checkbox" id="abuse-opt-separate"
                           checked={word.allowSeparateWord}
                           onChange={(e) => setWord(w => ({...w, allowSeparateWord: e.target.checked}))}/>
                    <label className="form-check-label" htmlFor="abuse-opt-separate"
                           title="Только как отдельное слово">
                        Отдельное слово {AbuseOptionsEmoji.SeparateWord}
                    </label>
                    <div className="small text-muted ms-4 ps-1">Не как подстрока внутри другого слова</div>
                </div>
            </Col>
            <Col sm={6}>
                <div className="form-check">
                    <input className="form-check-input" type="checkbox"
                           id="abuse-opt-ignorecase"
                           checked={word.allowIgnoreCase}
                           onChange={(e) => setWord(w => ({...w, allowIgnoreCase: e.target.checked}))}/>
                    <label className="form-check-label" htmlFor="abuse-opt-ignorecase">
                        Игнорировать регистр {AbuseOptionsEmoji.IgnoreCase}
                    </label>
                    <div className="small text-muted ms-4 ps-1">A и a считаются одинаковыми</div>
                </div>
            </Col>
        </Row>
    </div>
);
